import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

const
    transformEntitiesFn = account => {
        if (typeof account !== 'object') {
            throw new Error('transformAws needs an object to transform');
        }

        return {
            id:        account.id,
            name:      account.title || account.name,
            reselling: account.reselling
        };

    };

const exports = storeModuleFactory({
    name:             'vcloudAccounts',
    endpoint:         endpoints.accounts.vcloud.endpoint,
    instanceEndpoint: endpoints.accounts.vcloud.instanceEndpoint,
    transformEntitiesFn
});

exports.transformEntitiesFn = transformEntitiesFn;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/vcloudAccounts.js